var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysLightningOutlined = function SvgSysLightningOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.616 7.17c-.038 0-.038 0-.076-.003C1.117 7.12.81 6.7.852 6.232l.406-4.963c.04-.437.37-.769.765-.769h2.975c.085 0 .17.016.25.046.401.154.615.64.477 1.085l-.993 2.737h1.831a.71.71 0 0 1 .386.116c.367.236.492.759.279 1.167-.277.543-3.054 5.21-3.951 6.716-.072.12-.255.061-.246-.078l.3-5.122-1.715.004Z"
  })));
};
export default SvgSysLightningOutlined;